export const slbOceanSolutionsPdp = {
    oceanProduct: {
        ISVPurchase: "Sale",
        ISVRental: "Rent",
        ISVEvaluation: "Evaluation",
        ISVAcademic: "University",
        ISVDevelopment: "Development",
        SLBPurchase: "Buy",
        SLBRental: "Rent",
        SLBEvaluation: "Try",
        maintenance: "+ maintenance {{price}} / item per month",
        evaluation: '2 weeks free evaluation',
        license: "License",
        licenseType: "License type",
        purpose: "Purpose",
        purposeClient: "For a client",
        purposeDevelopment: "For development",
        purposeMessage: "You’ll be able to specify license duration in the cart",
        licenses: {
            SaleRental: 'Rental',
            Evaluation: 'Evaluation',
            Sale: 'Sale',
            Rental: 'Rental',
            Buy: 'Buy',
            University: "University",
            Academic: "University",
            Development: "Development"
        },
        rent: "Rent for {{for}} months",
        eval: "Evaluation for {{for}} days",
        item: '{{price}} / item',
        perMonth: '{{price}} / month',
        price: "Price",
        free: 'Free',
        freeFor: 'free evaluation',
        forWeeks: " for {{weeks}} weeks",
        itemPer: {
            month: '{{price}} item / month',
            total: '{{price}} / item total',
            year: '{{price}} item / year',
        },
        endDate: "Licence End Date",
        startDate: "Licence Start Date",
        maintDate: "Maint End Date",
        newOrder: "New Order",
        renewal: "Renewal",
        reHost: "Re-Host",
        till: "till {{endDate}}",
        totalPrice: {
            update: "Please update total line price as needed ", 
            tooltip: "You can update the total line price accordingly to the contract. <br/> The total line price should be the total for the period. <br/> For example for a Sale it would be the sale unit price plus the maintenance unit price times the number of users. <br/> And for Rental it would be the monthly rental unit price times the number of users times the number of rental months."
        }
    }
    
}